import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },
  selectedTabContent: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    height: "100%",
    boxShadow: "none",
  },
  selectedTabText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  calendarContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "none",
  },
  calendarTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  subTitleText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
    mt: 2,
  },
  searchBox: {
    mb: 2,
    backgroundColor: "transparent",
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  taskCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    mb: 2,
  },
  taskCardOverdue: {
    border: "2px solid rgb(253, 184, 184)",
    backgroundColor: colorsConstants.emergencyRequestCardBackground,
  },
  taskCardCompleted: {
    border: "2px solid rgba(76, 175, 80, 0.3)",
  },
  taskCardPriority: {
    border: "2px solid rgba(211, 47, 47, 0.45)",
  },
  taskTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1,
    mb: 1,
  },
  taskTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  taskMetaText: {
    color: colorsConstants.primaryText,
    mb: 0.5,
    opacity: 0.85,
  },
  taskDescriptionText: {
    color: colorsConstants.primaryText,
    mb: 1.5,
    opacity: 0.75,
  },
  taskActionsRow: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mt: 1,
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  modalActionsContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-evenly",
    mb: 1.5,
  },
  modalCancelButton: {
    color: colorsConstants.error,
  },
  modalTextField: {
    mt: 2,
    mb: 2,
    backgroundColor: "transparent",
  },
  timeslotsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    mb: 2,
  },
  noTasksText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  chipRow: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mb: 1,
  },
  colorPicker: {
    "& input": {
      height: "42px",
      padding: 1,
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
